import Vue from 'vue'
import LoadingVue from './loading.vue'

let LoadingConstructor = Vue.extend(LoadingVue)

let Loading = () => {
  let LoadingInstance = new LoadingConstructor()

  LoadingInstance.vm = LoadingInstance.$mount()
  LoadingInstance.vm.show = content => {
    LoadingInstance.vm.content = content || LoadingInstance.vm.content
    LoadingInstance.dom = LoadingInstance.vm.$el
    document.body.appendChild(LoadingInstance.dom)
    LoadingInstance.vm.visible = true
  }
  LoadingInstance.vm.hide = () => {
    LoadingInstance.vm.visible = false
  }
  return LoadingInstance.vm
}

export default {
  install: Vue => {
    Vue.prototype.$loading = Loading()
  }
}



// WEBPACK FOOTER //
// ./src/pages/cs180824/common/loading.js